import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-04aef7e7"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "permission-container"
};
const _hoisted_2 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "justify-content": "space-between"
  }
};
const _hoisted_3 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_4 = {
  style: {
    "margin-left": "20px"
  }
};
import { getAllPermissionList, addPermission, delPermission } from '@/api/permission';
import { ElMessage, ElMessageBox } from 'element-plus';
import { ref, onMounted } from 'vue';
import formDialog from './components/form-dialog/index.vue';
import { Search, Refresh } from '@element-plus/icons-vue';

// 所有权限

export default {
  __name: 'index',
  setup(__props) {
    const allPermission = ref([]);
    const loading = ref(false);
    const keyword = ref('');
    const getPermissionList = async () => {
      loading.value = true;
      const res = await getAllPermissionList({
        keyword: keyword.value
      });
      res.sort((a, b) => a.sort - b.sort);
      allPermission.value = res;
      loading.value = false;
    };
    onMounted(() => {
      getPermissionList();
    });
    const handleRefresh = () => {
      keyword.value = '';
      getPermissionList();
    };
    const onDeletePermissionHandler = row => {
      ElMessageBox.confirm('是否删除改权限', '温馨提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await delPermission(row.id);
        await getPermissionList();
      });
    };

    // 控制表单显示隐藏
    const isVisible = ref(false);
    const onAddPermissionHandler = () => {
      currentItem.value = {};
      isVisible.value = true;
    };
    const onConfirm = async val => {
      const sort = Math.max(...allPermission.value.map(item => item.sort));
      try {
        await addPermission({
          ...val,
          parentId: val.parentId || 0,
          tag: val.tag.join(','),
          effective: val.effective || 1,
          hidden: val.effective || 2,
          sort: val.sort || sort + 1
        });
        await getPermissionList();
        ElMessage.success('操作成功');
      } catch (error) {}
    };

    /**
     * 修改该权限
     */
    const currentItem = ref({});
    const onUpdatePermissionHandler = row => {
      currentItem.value = row;
      isVisible.value = true;
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_card = _resolveComponent("el-card");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _directive_permission = _resolveDirective("permission");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_card, {
        class: "header",
        shadow: "never",
        style: {
          "border": "none"
        }
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_input, {
          modelValue: keyword.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => keyword.value = $event),
          placeholder: "请输入关键字",
          style: {
            "width": "250px",
            "margin-right": "20px"
          }
        }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_button, {
          type: "primary",
          icon: _unref(Search),
          onClick: getPermissionList
        }, {
          default: _withCtx(() => [_createTextVNode(" 查询 ")]),
          _: 1
        }, 8, ["icon"]), _createVNode(_component_el_button, {
          icon: _unref(Refresh),
          onClick: handleRefresh
        }, {
          default: _withCtx(() => [_createTextVNode(" 重置 ")]),
          _: 1
        }, 8, ["icon"])])]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          onClick: onAddPermissionHandler
        }, {
          default: _withCtx(() => [_createTextVNode(" 添加权限 ")]),
          _: 1
        })), [[_directive_permission, ['permissionAdd']]])])]),
        _: 1
      }), _createVNode(_component_el_card, {
        shadow: "never",
        style: {
          "border": "none"
        }
      }, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: allPermission.value,
          style: {
            "width": "100%",
            "margin-bottom": "20px"
          },
          "row-key": "id",
          border: "",
          "default-expand-all": "",
          "tree-props": {
            children: 'childPermissions',
            hasChildren: 'hasChildren'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            prop: "name",
            label: "权限名",
            width: "240"
          }), _createVNode(_component_el_table_column, {
            prop: "url",
            label: "路径"
          }), _createVNode(_component_el_table_column, {
            prop: "tag",
            label: "标签",
            width: "480"
          }), _createVNode(_component_el_table_column, {
            label: "操作",
            prop: "action",
            width: "200"
          }, {
            default: _withCtx(({
              row
            }) => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
              type: "info",
              size: "small",
              onClick: $event => onUpdatePermissionHandler(row)
            }, {
              default: _withCtx(() => [_createTextVNode(" 修改 ")]),
              _: 2
            }, 1032, ["onClick"])), [[_directive_permission, ['permissionUpdate']]]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              type: "danger",
              size: "small",
              onClick: $event => onDeletePermissionHandler(row)
            }, {
              default: _withCtx(() => [_createTextVNode(" 删除 ")]),
              _: 2
            }, 1032, ["onClick"])), [[_directive_permission, ['permissionDelete']]])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"])), [[_directive_loading, loading.value]])]),
        _: 1
      }), _createVNode(formDialog, {
        item: currentItem.value,
        modelValue: isVisible.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => isVisible.value = $event),
        onConfirm: onConfirm
      }, null, 8, ["item", "modelValue"])]);
    };
  }
};